import styled from 'styled-components'

export const Title = styled.div`
  margin-top: 20px;
  font-weight: bold;
`
